import lilUri from 'lil-uri'

export function getUrlParameter (name) {
  const url = lilUri(window.location.href)
  const query = url.query()
  return query && query[name]
}



// WEBPACK FOOTER //
// ./src/tools/url.js